import { useServiceAppState } from '../../hooks';
import useCreateInstance from '../../hooks/useCreateAxiosInstance';
import { getIamApiFetchers } from './getIamApiFetchers';

const useIamApiInstance = () => {
  const {
    state: { token, iamEndpoint },
  } = useServiceAppState();

  const axiosInstance = useCreateInstance({
    baseURL: iamEndpoint,
    overrideOnFulfilled: response => response,
    overrideAxiosRequestConfig: {
      withCredentials: true,
    },
  });
  return getIamApiFetchers({ axiosInstance, iamEndpoint, token });
};

export default useIamApiInstance;
